import { functions } from '../../config/firebase'
import { getCallableErrorMessage } from '../ProductsSyncMenu/syncDateUtils'
import mapCampaignLinkFormToPayload from './mapCampaignLinkFormToPayload'

const createCampaignLink = async (formValues) => {
  try {
    const callable = functions.httpsCallable('createCampaignLink')
    const result = await callable(mapCampaignLinkFormToPayload(formValues))

    return {
      ok: true,
      data: result.data,
    }
  } catch (error) {
    console.error('[createCampaignLink] failed:', error)

    return {
      ok: false,
      message: getCallableErrorMessage(error),
    }
  }
}

export default createCampaignLink
